<template>
  <div>
    <b-row v-if="loading">
      <b-col cols="12">
        <loading-card />
      </b-col>
    </b-row>
    <template v-else>
      <b-row>
        <b-col cols="12">
          <h4 class="text-primary font-weight-bolder">
            Genel Toplam
          </h4>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <default-card
            title="Günlük"
            :value="customers.grandTotal.daily"
            icon="UserPlusIcon"
            color="success"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <default-card
            title="Aylık"
            :value="customers.grandTotal.monthly"
            icon="CalendarIcon"
            color="info"
          />
        </b-col>
        <b-col cols="12">
          <line-with-data-labels
            :series-data="customers.grandTotal.chartData.series"
            :labels-data="customers.grandTotal.chartData.labels"
            title-text="Müşteriler"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-for="(item,key) in customers.data"
          :key="key"
          cols="12"
          md="6"
        >
          <primary-heading
            :title-text="item.title"
            title-class="text-secondary"
          />
          <b-row>
            <b-col
              cols="6"
              md="6"
            >
              <default-card
                title="Günlük"
                :value="item.daily"
                color="success"
                icon="UserPlusIcon"
              />
            </b-col>
            <b-col
              cols="6"
              md="6"
            >
              <default-card
                title="Aylık"
                :value="item.monthly"
                color="info"
                icon="CalendarIcon"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import PrimaryHeading from '@/layouts/components/PrimaryHeading.vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import LineWithDataLabels from '@/layouts/components/ReportCharts/LineWithDataLabels.vue'

export default {
  name: 'SalesCustomers',
  components: {
    LineWithDataLabels,
    LoadingCard,
    DefaultCard,
    PrimaryHeading,
    BRow,
    BCol,
  },
  computed: {
    loading() {
      return this.$store.getters['saleCustomersReports/loading']
    },
    customers() {
      return this.$store.getters['saleCustomersReports/customers']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('saleCustomersReports/getCustomers')
    },
  },
}
</script>
